module.exports = __webpack_public_path__ + "static/audit-5c2dc953f44c19f31ce3f30f6b70517a.png";